import { Accordion } from "@/components/ui/accordion";
import { useAuthStore } from "@/store/auth.store";
import type { EntryResult } from "@roman/shared/types/Result";
import { useMemo, useState } from "react";
import { ShowOnlyMyTeam } from "../Schedule/ScheduleUsersTab";
import { EntryRow } from "./EntryRow";

export const UsersTab = ({
  entries,
  onSelectEntry,
  playerImageMap,
}: {
  entries: EntryResult[];
  onSelectEntry: (entry: EntryResult | null) => void;
  playerImageMap: Record<string, string | null>;
}) => {
  const [showOnlyMyTeam, setShowOnlyMyTeam] = useState(false);
  const [expandedValues, setExpandedValues] = useState<string[]>([]);
  const user = useAuthStore((state) => state.user);

  const displayEntries = user && showOnlyMyTeam ? entries.filter((entry) => entry.userId === user.id) : entries;

  const rankWidth = useMemo(() => {
    if (displayEntries.length < 100) {
      return "w-5";
    }
    if (displayEntries.length < 1000) {
      return "w-7";
    }
    return "w-9";
  }, [displayEntries]);

  return (
    <div className="py-2">
      <ShowOnlyMyTeam
        onClick={() => setShowOnlyMyTeam((prev) => !prev)}
        className={showOnlyMyTeam ? "bg-secondary" : "bg-disabled"}
      />

      <Accordion
        className="py-2"
        type="multiple"
        value={expandedValues}
        onValueChange={(value) => setExpandedValues(value)}
      >
        {displayEntries.map((entry, index) => {
          const isYourEntry = entry.userId === user?.id;
          return (
            <EntryRow
              key={`entry-${entry.id}-${index}`}
              entry={entry}
              isYourEntry={isYourEntry}
              onSelectEntry={onSelectEntry}
              index={index}
              setExpandedValues={setExpandedValues}
              rankWidth={rankWidth}
              playerImageMap={playerImageMap}
            />
          );
        })}
      </Accordion>
    </div>
  );
};
